import type { SVGProps } from "react";

const base: SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V9.5z" /></svg>);
}

export function BuildingIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M9 7h6M9 11h6M9 15h4" /></svg>);
}

export function CardIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><rect x="3" y="6" width="18" height="14" rx="2" /><path d="M3 10h18M7 16h2" /></svg>);
}

export function ChartIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M3 3v18h18" /><path d="M7 14l4-4 3 3 5-5" /></svg>);
}

export function ShieldIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M12 3l8 4v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7l8-4z" /></svg>);
}

export function MegaphoneIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M3 11l18-7v16l-18-7v-2zM7 11v6" /></svg>);
}

export function UsersIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3 3-5 6-5s6 2 6 5M16 11a3 3 0 0 0 0-6M21 20c0-2-2-4-5-4.5" /></svg>);
}

export function CogIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>);
}

export function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.5-4.5" /></svg>);
}

export function PlusIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M12 5v14M5 12h14" /></svg>);
}

export function MoreIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><circle cx="12" cy="12" r="1.5" /><circle cx="12" cy="5" r="1.5" /><circle cx="12" cy="19" r="1.5" /></svg>);
}

export function LogOutIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>);
}

export function EyeIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>);
}

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M5 12l5 5L20 7" /></svg>);
}

export function ArrowUpIcon(props: SVGProps<SVGSVGElement>) {
  return (<svg {...base} {...props}><path d="M12 19V5M5 12l7-7 7 7" /></svg>);
}

// KLUB-264 — drag handle grip: 2×3 dots. Filled, not stroked, so it reads as
// a texture to grab rather than an action icon.
export function GripIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base} stroke="none" fill="currentColor" {...props}>
      <circle cx="9" cy="5" r="1.6" /><circle cx="15" cy="5" r="1.6" />
      <circle cx="9" cy="12" r="1.6" /><circle cx="15" cy="12" r="1.6" />
      <circle cx="9" cy="19" r="1.6" /><circle cx="15" cy="19" r="1.6" />
    </svg>
  );
}
